// extracted by mini-css-extract-plugin
export default {"background":"main_background__i0azX"};